import { render, staticRenderFns } from "./PersonalMenuLabel.vue?vue&type=template&id=7ac9ff18&scoped=true"
import script from "./PersonalMenuLabel.vue?vue&type=script&lang=js"
export * from "./PersonalMenuLabel.vue?vue&type=script&lang=js"
import style0 from "./PersonalMenuLabel.vue?vue&type=style&index=0&id=7ac9ff18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac9ff18",
  null
  
)

export default component.exports